import { Controller } from "@hotwired/stimulus"

// Make sure the controller name matches the kebab-case format used in the HTML
export default class extends Controller {
  static values = {
    id: String
  }
  
  connect() {
  }
  
  generateLink(event) {
    event.preventDefault()
    
    const button = event.currentTarget
    const originalText = button.textContent
    
    // Show loading state
    button.textContent = "Generating..."
    button.disabled = true
    
    // Get the invitation token from the data attribute
    const token = this.idValue
    
    
    // Call the direct_link endpoint
    fetch(`/accounts/${this.getAccountId()}/invitations/${token}/direct_link`, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'X-CSRF-Token': this.getCSRFToken()
      }
    })
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`)
      }
      return response.json()
    })
    .then(data => {
      
      if (!data.direct_url) {
        throw new Error("No direct URL returned from server")
      }
      
      
      // Copy the direct URL to clipboard
      return navigator.clipboard.writeText(data.direct_url)
        .then(() => {
          // Show success state
          button.textContent = "Copied!"
          button.classList.remove("btn-primary")
          button.classList.add("btn-success")
          
          // Reset button after delay
          setTimeout(() => {
            button.textContent = originalText
            button.disabled = false
            button.classList.remove("btn-success")
            button.classList.add("btn-primary")
          }, 2000)
        })
    })
    .catch(error => {
      console.error('Error generating direct link:', error)
      button.textContent = "Error!"
      button.classList.remove("btn-primary")
      button.classList.add("btn-danger")
      
      // Reset button after delay
      setTimeout(() => {
        button.textContent = originalText
        button.disabled = false
        button.classList.remove("btn-danger")
        button.classList.add("btn-primary")
      }, 2000)
    })
  }
  
  // Helper to get the account ID from the URL
  getAccountId() {
    const pathParts = window.location.pathname.split('/')
    const accountIndex = pathParts.indexOf('accounts')
    return pathParts[accountIndex + 1]
  }
  
  // Helper to get CSRF token
  getCSRFToken() {
    return document.querySelector('meta[name="csrf-token"]').getAttribute('content')
  }
}
